import React from "react";
import { ToastContainer } from "react-toastify";
import MetaAdAccountSelector from "./components/MetaAdAccountSelector";
import MetaAdsFinanceMapping from "./components/MetaAdsFinanceMapping";
import "./styles/metaAdsSettings.css";

const MetaAdAccountSelectorApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <MetaAdAccountSelector {...props} />
      <MetaAdsFinanceMapping {...props} />
    </>
  );
};

export default MetaAdAccountSelectorApp;
